import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { mergeMap, withLatestFrom } from 'rxjs/operators';
import { Actions } from '../../actions';
import { CleanMerchStore, CreateMerchError } from '../action-creators';
import { CREATE_MERCH_ERROR } from '../actions';
import { CreateDialog, NoOp } from '@webapp/store/ui/action-creators';
import { push } from 'connected-react-router';
import store from '@webapp/store';
import AppState from '@webapp/store/state';
import { merchReleaseInitiatedEvent } from '@webapp/utils/rudderstack/events';

export const showUnavailableMerchEpic = (
  action$: Observable<Actions>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Actions, CreateMerchError>(CREATE_MERCH_ERROR),
    withLatestFrom(state$),
    mergeMap(async ([action, state]) => {
      if (action.code === 'PRINTIFY.CREATE_PRODUCT') {
        return new CreateDialog(
          `UNAVAILABLE_PRODUCT.${Date.now().toString()}`,
          {
            open: true,
            title: `Product Unavailable.`,
            text: `We're sorry. The product you selected is currently unavailable.`,
            actions: [{ type: 'primary', label: 'OK', value: true }],
            callback: async (result) => {
              if (result) {
                store.dispatch(new CleanMerchStore());
                merchReleaseInitiatedEvent({
                  artist_id: state.artist.active?.id,
                  artist_name: state.artist.active?.name,
                }).then(() => {
                  push('/merch');
                });
              }
            },
          }
        );
      }
      return new NoOp();
    })
  );
